module.exports = __webpack_public_path__ + "media/MRI13-ad.0dce6d58.mp3";